import { render, staticRenderFns } from "./ZakaznikSelect.vue?vue&type=template&id=b4bb2eee&"
import script from "./ZakaznikSelect.vue?vue&type=script&lang=ts&"
export * from "./ZakaznikSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports